import React, { useMemo, useState } from "react";
import NewSearch from "../../components/Mobile/NewSearch";
import { ReactComponent as Chatbot } from "../../icons/Chatbot.svg";
import { ReactComponent as ArrowRight } from "../../icons/RightArrow.svg";
import { ReactComponent as Staff } from "../../icons/Staff.svg";
// import {
//   useCompleteSignIn,
//   useLoadAccountMemberships,
// } from "../../hooks/authhooks";
import { CommunitySchema, MembershipSchema } from "../../data/types";
import { filterMessageMemberships } from "../../utils/helpers";

// const capitalizeString = (string: string) =>
//   string?.replace(/\w/, (c) => c?.toUpperCase());

type UserListWindowProps = {
  username: string;
  accountMemberships: MembershipSchema[];
  choosingChat: boolean;
  setChoosingChat: () => void;
  selectedChat: string;
  setSelectedChat: React.Dispatch<React.SetStateAction<string>>;
  selectedCommunity?: CommunitySchema;
  setSelectedCommunity?: React.Dispatch<React.SetStateAction<CommunitySchema | undefined>>;
};

const UserListWindow: React.FC<UserListWindowProps> = ({
  username,
  accountMemberships,
  setChoosingChat,
  setSelectedChat,
  setSelectedCommunity,
}) => {
  const [searchTerm, changeSearchTerm] = useState("");
  const [filterSetting, setFilterSetting] = useState<boolean>(false);

  // const { user } = useCompleteSignIn();
  // const loggedin_username = user && user?.username ? user.username : "";
  // const { accountMemberships } = useLoadAccountMemberships(loggedin_username);

  const toggleFilterSetting = () => {
    setFilterSetting(!filterSetting);
  };

  const filteredMemberships = useMemo(
    () => filterMessageMemberships(accountMemberships ?? [], searchTerm),
    [accountMemberships, searchTerm]
  );

  const useFixedChatListHeight =
    (accountMemberships?.length ?? 0) > 1 || filteredMemberships.length > 1;

  return (
    <div className="flex flex-col h-full">
      {/* Search Bar */}
      <div className="flex-shrink-0 px-3 sm:px-4 pt-3 sm:pt-4 pb-2 bg-white border-b border-gray-100">
        <NewSearch
          searchTerm={searchTerm}
          toggleFilterSetting={toggleFilterSetting}
          filterSetting={filterSetting}
          changeSearchTerm={changeSearchTerm}
          searchType="messages"
        />
      </div>

      <div
        className={`px-3 sm:px-4 py-3 sm:py-4 ${
          useFixedChatListHeight
            ? "h-[280px] sm:h-[300px] flex-shrink-0 overflow-y-auto"
            : ""
        }`}
      >
        <div className="flex flex-col gap-2 sm:gap-3">
          <ChatUser
            currentChatCommunity="chatbot"
            member={username}
            allThreadsByCommunity={""}
            setSelectedChat={setSelectedChat}
            setMessageOpen={() => setChoosingChat()}
          />
          <ChatUser
            currentChatCommunity="staff"
            member={username}
            allThreadsByCommunity={""}
            setSelectedChat={setSelectedChat}
            setMessageOpen={() => setChoosingChat()}
          />
          {filteredMemberships.map((membership: MembershipSchema, index: number) => (
              <ChatUser
                key={membership.community_id || membership.id || index}
                currentChatCommunity={membership.community_id || membership.id || ""}
                member={membership.username || ""}
                membership={membership}
                allThreadsByCommunity={""}
                setSelectedChat={setSelectedChat}
                setSelectedCommunity={setSelectedCommunity}
                setMessageOpen={() => setChoosingChat()}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

type ChatUserProps = {
  member: string;
  currentChatCommunity: string;
  membership?: MembershipSchema;
  setSelectedChat: React.Dispatch<React.SetStateAction<string>>;
  setSelectedCommunity?: React.Dispatch<React.SetStateAction<CommunitySchema | undefined>>;
  allThreadsByCommunity: any;
  setMessageOpen: any;
};

const ChatUser: React.FC<ChatUserProps> = ({
  member,
  membership,
  currentChatCommunity,
  setSelectedChat,
  setSelectedCommunity,
  setMessageOpen,
}) => {
  const handleClick = () => {
    if (setSelectedChat) {
      setSelectedChat(currentChatCommunity);
    }
    if (setSelectedCommunity) {
      setSelectedCommunity(membership);
    }
    setMessageOpen();
  };

  if (currentChatCommunity !== "chatbot") {
    return (
      <button
        className="flex items-center gap-3 sm:gap-4 p-3 sm:p-4 cursor-pointer bg-white hover:bg-gray-50 active:bg-gray-100 rounded-xl border border-gray-200 hover:border-primaryDark-300 transition-all duration-200 w-full text-left"
        onClick={handleClick}
      >
        <div className="flex-shrink-0">
          {membership ? (
            <img 
              src={membership.logo} 
              alt={membership.name || "Community"} 
              className="rounded-full h-12 w-12 sm:h-14 sm:w-14 object-scale-down border-2 border-gray-100"
            />
          ) : (
            <div className="h-12 w-12 sm:h-14 sm:w-14 rounded-full bg-primaryDark-0/10 flex items-center justify-center">
              <Staff className="h-6 w-6 sm:h-7 sm:w-7 text-primaryDark-0" />
            </div>
          )}
        </div>
        <div className="flex flex-col flex-1 min-w-0">
          <p className="font-raleway font-bold text-sm sm:text-base text-[#2D3748] truncate">
            {membership?.name || "Chat with a staff member"}
          </p>
          <p className="text-[#7A7A7A] font-normal text-xs sm:text-sm font-open-sans truncate">
            Start a conversation
          </p>
        </div>
        <ArrowRight className="flex-shrink-0 h-5 w-5 sm:h-6 sm:w-6 text-gray-400" />
      </button>
    );
  } else {
    return (
      <button
        className="flex items-center gap-3 sm:gap-4 p-3 sm:p-4 cursor-pointer bg-white hover:bg-gray-50 active:bg-gray-100 rounded-xl border border-gray-200 hover:border-primaryDark-300 transition-all duration-200 w-full text-left"
        onClick={handleClick}
      >
        <div className="flex-shrink-0 h-12 w-12 sm:h-14 sm:w-14 rounded-full bg-[#51a0b5]/10 flex items-center justify-center">
          <Chatbot className="h-6 w-6 sm:h-7 sm:w-7 text-primaryDark-0/90" />
        </div>
        <div className="flex flex-col flex-1 min-w-0">
          <p className="font-raleway font-bold text-sm sm:text-base text-[#2D3748] truncate">
            Chat with AI Assistant
          </p>
          <p className="text-[#7A7A7A] font-normal text-xs sm:text-sm font-open-sans truncate">
            Start a conversation
          </p>
        </div>
        <ArrowRight className="flex-shrink-0 h-5 w-5 sm:h-6 sm:w-6 text-gray-400" />
      </button>
    );
  }
};

export default UserListWindow;
